import { FC, ReactNode } from 'react';
import classNames from 'classnames';

import { useTheme } from 'context/theme';
import { StyledComponent } from 'types';

type ConditionLabelValueGroupProps = {
  label?: ReactNode;
  value: ReactNode;
  valueSuffix?: ReactNode;
} & StyledComponent;

export const ConditionLabelValueGroup: FC<ConditionLabelValueGroupProps> = ({
  label,
  value,
  valueSuffix,
  className
}) => {
  const { isDark, isDefault } = useTheme();

  return (
    <div
      className={classNames('px-3 my-3 border-start d-flex flex-column riforma-regular', className, {
        'text-primary': isDefault,
        'text-light border-light20': isDark
      })}
    >
      {label && (
        <span className='fs-14px mb-1'>
          {label}
          <span className='invisible'>:&nbsp;</span>
        </span>
      )}
      <span className='fs-14px'>
        <span style={{ whiteSpace: 'pre-wrap' }} className='opacity-60'>
          {value}
        </span>
        {valueSuffix && <span>{valueSuffix}</span>}
      </span>
    </div>
  );
};
